import React, { useContext } from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import ThemeContext from 'shared/context/ThemeContext';
import CopySelector from 'shared/utils/copySelector';
import { styles } from '../../styles';

const TiFormFooter = ({ handleOpenTerms, enableOrderCard, handleRegisterRewardCard }) => {
  const { FormFooter } = useContext(ThemeContext);

  return (
    <p style={styles.termsText}>
      {enableOrderCard && (
        <>
          {`${CopySelector.getCopy(CopySelector.COPY_TYPES.LINK_CARD_SIGNUP)}`}{' '}
          <a style={FormFooter.TermsLink} onClick={handleRegisterRewardCard}>
            {CopySelector.getCopy(CopySelector.COPY_TYPES.LINK_CARD_SIGNUP_CTA)}
          </a>{' '}
        </>
      )}
      {getText(TEXT_KEY.TERMS_AGREE_MESSAGE)}{' '}
      <a style={FormFooter.TermsLink} onClick={handleOpenTerms}>
        {getText(TEXT_KEY.TERMS_OF_SERVICE)}
      </a>
    </p>
  );
};

export default TiFormFooter;

